


















































































































import Vue, { PropType } from 'vue'
import { SubscriptionBase, SubscriptionStatus } from '@/types/generated/graphql'
import XCard from '@/components/atoms/Card/XCard.vue'
import XList from '@/components/atoms/List/XList.vue'
import XListItem from '@/components/atoms/List/XListItem.vue'
import XStatusLabel from '@/components/atoms/Chip/XStatusLabel.vue'
import ItemValue from '@/components/molecules/Subscription/List/Item/Partial/ItemValue.vue'

type Data = {
  SubscriptionStatus: typeof SubscriptionStatus
}

type Props = {
  value: SubscriptionBase
}

export default Vue.extend<Data, {}, {}, Props>({
  name: 'Subscription',
  components: { XCard, XList, XListItem, XStatusLabel, ItemValue },
  data() {
    return {
      SubscriptionStatus,
    }
  },
  props: {
    value: {
      type: Object as PropType<SubscriptionBase>,
    },
  },
})
